import { css } from "styled-components";
import rubikLatin300Eot from "./rubik/rubik-v12-latin-300.eot";
import rubikLatin300Woff2 from "./rubik/rubik-v12-latin-300.woff2";
import rubikLatin300Woff from "./rubik/rubik-v12-latin-300.woff";
import rubikLatin300Ttf from "./rubik/rubik-v12-latin-300.ttf";
import rubikLatin300Svg from "./rubik/rubik-v12-latin-300.svg";

import rubikLatinRegularEot from "./rubik/rubik-v12-latin-regular.eot";
import rubikLatinRegularWoff2 from "./rubik/rubik-v12-latin-regular.woff2";
import rubikLatinRegularWoff from "./rubik/rubik-v12-latin-regular.woff";
import rubikLatinRegularTtf from "./rubik/rubik-v12-latin-regular.ttf";
import rubikLatinRegularSvg from "./rubik/rubik-v12-latin-regular.svg";

import rubikLatin500Eot from "./rubik/rubik-v12-latin-500.eot";
import rubikLatin500Woff2 from "./rubik/rubik-v12-latin-500.woff2";
import rubikLatin500Woff from "./rubik/rubik-v12-latin-500.woff";
import rubikLatin500Ttf from "./rubik/rubik-v12-latin-500.ttf";
import rubikLatin500Svg from "./rubik/rubik-v12-latin-500.svg";

import rubikLatin600Eot from "./rubik/rubik-v12-latin-600.eot";
import rubikLatin600Woff2 from "./rubik/rubik-v12-latin-600.woff2";
import rubikLatin600Woff from "./rubik/rubik-v12-latin-600.woff";
import rubikLatin600Ttf from "./rubik/rubik-v12-latin-600.ttf";
import rubikLatin600Svg from "./rubik/rubik-v12-latin-600.svg";

import rubikLatin700Eot from "./rubik/rubik-v12-latin-700.eot";
import rubikLatin700Woff2 from "./rubik/rubik-v12-latin-700.woff2";
import rubikLatin700Woff from "./rubik/rubik-v12-latin-700.woff";
import rubikLatin700Ttf from "./rubik/rubik-v12-latin-700.ttf";
import rubikLatin700Svg from "./rubik/rubik-v12-latin-700.svg";

import rubikLatin800Eot from "./rubik/rubik-v12-latin-800.eot";
import rubikLatin800Woff2 from "./rubik/rubik-v12-latin-800.woff2";
import rubikLatin800Woff from "./rubik/rubik-v12-latin-800.woff";
import rubikLatin800Ttf from "./rubik/rubik-v12-latin-800.ttf";
import rubikLatin800Svg from "./rubik/rubik-v12-latin-800.svg";

import rubikLatin900Eot from "./rubik/rubik-v12-latin-900.eot";
import rubikLatin900Woff2 from "./rubik/rubik-v12-latin-900.woff2";
import rubikLatin900Woff from "./rubik/rubik-v12-latin-900.woff";
import rubikLatin900Ttf from "./rubik/rubik-v12-latin-900.ttf";
import rubikLatin900Svg from "./rubik/rubik-v12-latin-900.svg";

export const Rubik = css`
    /* rubik-300 - latin */
    @font-face {
        font-family: "Rubik";
        font-display: swap;
        font-style: normal;
        font-weight: 300;
        src: url(${rubikLatin300Eot}); /* IE9 Compat Modes */
        src: local(""), url(${rubikLatin300Eot}) format("embedded-opentype"),
            /* IE6-IE8 */ url(${rubikLatin300Woff2}) format("woff2"),
            /* Super Modern Browsers */ url(${rubikLatin300Woff}) format("woff"),
            /* Modern Browsers */ url(${rubikLatin300Ttf}) format("truetype"),
            /* Safari, Android, iOS */ url(${rubikLatin300Svg}) format("svg"); /* Legacy iOS */
    }
    /* rubik-regular - latin */
    @font-face {
        font-family: "Rubik";
        font-display: swap;
        font-style: normal;
        font-weight: 400;
        src: url(${rubikLatinRegularEot}); /* IE9 Compat Modes */
        src: local(""), url(${rubikLatinRegularEot}) format("embedded-opentype"),
            /* IE6-IE8 */ url(${rubikLatinRegularWoff2}) format("woff2"),
            /* Super Modern Browsers */ url(${rubikLatinRegularWoff})
                format("woff"),
            /* Modern Browsers */ url(${rubikLatinRegularTtf})
                format("truetype"),
            /* Safari, Android, iOS */ url(${rubikLatinRegularSvg})
                format("svg"); /* Legacy iOS */
    }
    /* rubik-500 - latin */
    @font-face {
        font-family: "Rubik";
        font-display: swap;
        font-style: normal;
        font-weight: 500;
        src: url(${rubikLatin500Eot}); /* IE9 Compat Modes */
        src: local(""), url(${rubikLatin500Eot}) format("embedded-opentype"),
            /* IE6-IE8 */ url(${rubikLatin500Woff2}) format("woff2"),
            /* Super Modern Browsers */ url(${rubikLatin500Woff}) format("woff"),
            /* Modern Browsers */ url(${rubikLatin500Ttf}) format("truetype"),
            /* Safari, Android, iOS */ url(${rubikLatin500Svg}) format("svg"); /* Legacy iOS */
    }
    /* rubik-600 - latin */
    @font-face {
        font-family: "Rubik";
        font-display: swap;
        font-style: normal;
        font-weight: 600;
        src: url(${rubikLatin600Eot}); /* IE9 Compat Modes */
        src: local(""), url(${rubikLatin600Eot}) format("embedded-opentype"),
            /* IE6-IE8 */ url(${rubikLatin600Woff2}) format("woff2"),
            /* Super Modern Browsers */ url(${rubikLatin600Woff}) format("woff"),
            /* Modern Browsers */ url(${rubikLatin600Ttf}) format("truetype"),
            /* Safari, Android, iOS */ url(${rubikLatin600Svg}) format("svg"); /* Legacy iOS */
    }
    /* rubik-700 - latin */
    @font-face {
        font-family: "Rubik";
        font-display: swap;
        font-style: normal;
        font-weight: 700;
        src: url(${rubikLatin700Eot}); /* IE9 Compat Modes */
        src: local(""), url(${rubikLatin700Eot}) format("embedded-opentype"),
            /* IE6-IE8 */ url(${rubikLatin700Woff2}) format("woff2"),
            /* Super Modern Browsers */ url(${rubikLatin700Woff}) format("woff"),
            /* Modern Browsers */ url(${rubikLatin700Ttf}) format("truetype"),
            /* Safari, Android, iOS */ url(${rubikLatin700Svg}) format("svg"); /* Legacy iOS */
    }
    /* rubik-800 - latin */
    @font-face {
        font-family: "Rubik";
        font-display: swap;
        font-style: normal;
        font-weight: 800;
        src: url(${rubikLatin800Eot}); /* IE9 Compat Modes */
        src: local(""), url(${rubikLatin800Eot}) format("embedded-opentype"),
            /* IE6-IE8 */ url(${rubikLatin800Woff2}) format("woff2"),
            /* Super Modern Browsers */ url(${rubikLatin800Woff}) format("woff"),
            /* Modern Browsers */ url(${rubikLatin800Ttf}) format("truetype"),
            /* Safari, Android, iOS */ url(${rubikLatin800Svg}) format("svg"); /* Legacy iOS */
    }
    /* rubik-900 - latin */
    @font-face {
        font-family: "Rubik";
        font-display: swap;
        font-style: normal;
        font-weight: 900;
        src: url(${rubikLatin900Eot}); /* IE9 Compat Modes */
        src: local(""), url(${rubikLatin900Eot}) format("embedded-opentype"),
            /* IE6-IE8 */ url(${rubikLatin900Woff2}) format("woff2"),
            /* Super Modern Browsers */ url(${rubikLatin900Woff}) format("woff"),
            /* Modern Browsers */ url(${rubikLatin900Ttf}) format("truetype"),
            /* Safari, Android, iOS */ url(${rubikLatin900Svg}) format("svg"); /* Legacy iOS */
    }
`;
